import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from 'src/app/config/app.config.service';
import { Observable, Subject, catchError, map } from 'rxjs';
import { ErrorService } from 'src/app/core/shared/services/error.service';
import { Equipement } from 'src/app/core/shared/models/equipement';


@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  bcCoreApiUrl = AppConfigService.settings.bcCoreApiUrl;
  customApiUrlSegment = AppConfigService.settings.customApiUrlSegment;
  bcEnvirName = AppConfigService.settings.bcEnvirName;
  defaultLg = AppConfigService.settings.defaultLanguage;
  schemaVersion = AppConfigService.settings.bcSchemaversion;
  
  public newMultipleCorrectifWOrkOrderEquipement: Subject<any> = new Subject<any>();
  public maganePermssionEvent: Subject<any> = new Subject<any>();
  
    constructor(private http: HttpClient,
      private errorService: ErrorService  ) { }
  
     // Http Options
    httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'If-Match': '*',
        'Accept-Language': 'fr-CA'
      }),
    }; 

    editStatus(tenantId: any, companyId: string, workOrderId, data: any): Observable<any>{  
      const url = this.bcCoreApiUrl+tenantId+"/"+this.bcEnvirName+"/"+ this.customApiUrlSegment + "/companies("+companyId+")/workOrders("+workOrderId+")/Microsoft.NAV.changeStatus?$schemaversion="+this.schemaVersion ;  
      return this.http.post(url, data, this.httpOptions).pipe(
        map(result  => result as Equipement),
        catchError(this.errorService.handleError));
    }

    checkchangeStatus(tenantId: any, companyId: string, workOrderId, data: any): Observable<any>{  
      const url = this.bcCoreApiUrl+tenantId+"/"+this.bcEnvirName+"/"+ this.customApiUrlSegment + "/companies("+companyId+")/workOrders("+workOrderId+")/Microsoft.NAV.checkchangeStatus?$schemaversion="+this.schemaVersion ;  
      return this.http.post(url, data, this.httpOptions).pipe(
        map(result  => result as Equipement),
        catchError(this.errorService.handleError));
    }

    getreturnOrderNo(tenantId: any, companyId: string): Observable<any>{  
      const url = this.bcCoreApiUrl+tenantId+"/"+this.bcEnvirName+"/"+ this.customApiUrlSegment + "/companies("+companyId+")/eraWOReturnOrder?$schemaversion="+this.schemaVersion ;     
      return this.http.get(url, this.httpOptions).pipe(
        catchError(this.errorService.handleError));
    }

    shipReceiptItems(
    tenantId: any,
    companyId: string,
    body: any
  ): Observable<any> {
    const url =
      this.bcCoreApiUrl +
      tenantId +
      '/' +
      this.bcEnvirName +
      '/' +
      'ODataV4/ShipReceiveItems_ShipReceiptItems?Company='+companyId;
    return this.http
      .post(url, JSON.stringify(body), this.httpOptions)
      .pipe(catchError(this.errorService.handleError));
  }
  
  }
